const apiKey = "AIzaSyCOC-0oOv29SsXRW-xDkMX1I3G1n4UHvws";

export default apiKey;
